import { render } from "./InfoPepAccionista_Juridico.vue?vue&type=template&id=28049f92&ts=true"
import script from "./InfoPepAccionista_Juridico.vue?vue&type=script&lang=ts"
export * from "./InfoPepAccionista_Juridico.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\agentcloudALProd\\_work\\12\\s\\AEL.NominaElectronica.Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__